import { EventScheduleFieldsFragment } from '~/graphql/hasura';

export function commaSeperatedSpeakerNames(
    speakers: Pick<EventScheduleFieldsFragment, 'speakers'>['speakers']
): string {
    let speakerNames = '';
    speakers.forEach(({ speaker }, index) => {
        speakerNames += `${speaker.pre_title} ${speaker.firstname} ${speaker.lastname}`;
        if (index < speakers.length - 1) {
            speakerNames += ', ';
        }
    });
    return speakerNames;
}
